/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, oneOf as codecOneOf, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { UserInput } from './UserInput';
const EmailUsersCourseDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    /* #__PURE__ */ parsers.object([
        ['subject', codecString],
        ['body', codecString],
        ['emailAllUsers', codecBoolean, 'email_all_users'],
        ['usernames', /* #__PURE__ */ codecArray(codecString)],
    ]),
    /* #__PURE__ */ parsers.object([
        ['subject', codecString],
        ['body', codecString],
        ['emailAllUsers', codecBoolean, 'email_all_users'],
        ['users', /* #__PURE__ */ codecArray(UserInput)],
    ]),
]);
export const EmailUsersCourseData = EmailUsersCourseDataParser;
